import React, { useEffect, useState } from "react";
import { Input, Spin } from "antd";
import { isEmpty, filter } from "lodash";

import "./index.scss";
import markerIcons from "../Markers/markerIcons";
import { STATUS, COLOR_DEFAULT } from "../../constants";
import { getTranslation } from "../../utils/helper";

const defaultColor = COLOR_DEFAULT;

const SearchStops = ({ stops, onClickStop, setClicked, setting }) => {
  const [searchValue, setSearchValue] = useState(null);
  const [searchedStops, setSearchedStops] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleClickStop = stop => {
    setClicked(true);
    onClickStop(stop);
  };

  useEffect(() => {
    if (!isEmpty(searchValue)) {
      const stopsT = filter(stops, o => {
        return (
          o.address?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          o.driverName?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          o.name?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          o.orderCode?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          o.orderRef?.toString().toLowerCase().match(searchValue.toLowerCase())
        );
      });
      setSearchedStops(stopsT);
    }
  }, [searchValue]);

  const handleOnSearch = e => {
    setLoading(true);
    setTimeout(() => {
      setSearchValue(e.target.value);
      setLoading(false);
    }, 100);
  };

  useEffect(() => {
    setSearchedStops(stops);
  }, [stops]);

  return (
    <div className="SearchStops">
      <div className="SearchBox">
        <Input.Search allowClear placeholder="Search stop" onChange={handleOnSearch} />
      </div>
      {!isEmpty(searchValue) && (
        <Spin spinning={loading}>
          <div className="StopsList">
            <div className="Title">{searchedStops.length} stops found</div>
            {searchedStops.map((stop, index) => {
              const status = STATUS.find(s => s.code === stop?.status);
              const driverName = stop?.driverName ?? "Driver";
              return (
                <div key={index} className="StopItem order-popup" onClick={() => handleClickStop(stop)}>
                  <div className="header">
                    <div className="left">
                      <div
                        className={`type ${stop.type}`}
                        style={{
                          border: `1px solid #${stop.color || defaultColor}`,
                          color: `#${stop.color || defaultColor}`,
                        }}>
                        {index + 1}
                      </div>
                      {stop.orderRef || stop.orderCode}
                    </div>
                    <div className="right">
                      {driverName && (
                        <div className="driverInfo">
                          <img src={markerIcons["driver"][stop.color || defaultColor]} alt={driverName} />
                          {driverName}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="content-top">
                    <span className={`status orderStatus ${status?.code?.toLowerCase()}`}>
                      {getTranslation(setting, "Orders", status?.name ?? "N/A")}
                    </span>
                    <div className="name">{stop.name}</div>
                  </div>
                  <div className="content-address">{stop.address}</div>
                </div>
              );
            })}
          </div>
        </Spin>
      )}
    </div>
  );
};

export default SearchStops;
